import { combineReducers } from 'redux';

import creatorState, { creatorInitialState } from './creator';
import listState, { listInitialState } from './list';

export const dataStorageInitialState = { 
  creatorState: creatorInitialState,
  listState: listInitialState
}

export const dataStorageState = combineReducers({ 
  creatorState,
  listState
})